import { SearchV2 } from '@cimplico/components';
import { useEffect, useMemo, useState } from 'react';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useCalculationTemplates } from '../../queries/resources/calculation-templates';
import { useCalculations } from '../../queries/use-calculations';
import { CWTBehaviourEnum } from '../../types/custom-worksheet-v2';
import BlankCard from './BlankCard';
import CalculationTemplateCard from './CalculationTemplateCard';
import ManualForm from './ManualForm';

function NewOtherScheduleForm(): JSX.Element {
    const { entity } = useWorkpaperContext();
    const [showManualForm, setShowManualForm] = useState(false);
    const [search, setSearch] = useState<string>();
    const templatesQuery = useCalculationTemplates({
        allowAsSchedule: true,
        entityType: [entity.type],
        status: 'PUBLISHED',
        search,
    });
    const calculationsQuery = useCalculations();

    const isLoading = templatesQuery.isLoading || calculationsQuery.isLoading;
    const isFetching = templatesQuery.isFetching || calculationsQuery.isFetching;

    const templates = useMemo(() => templatesQuery.data?.templates ?? [], [templatesQuery.data?.templates]);
    const calculations = calculationsQuery.data?.calculations ?? [];

    const [isCreating, setIsCreating] = useState(false);

    function handleManualFormCancel(): void {
        setShowManualForm(false);
    }

    // Auto show the manual form if there's no available templates
    useEffect(() => {
        if (!isLoading && !templates.length && !search) {
            setShowManualForm(true);
        }
    }, [templates, isLoading, search]);

    if (showManualForm) {
        return <ManualForm onCancel={handleManualFormCancel} />;
    }

    return (
        <div
            className="grid gap-4 grid-cols-[repeat(auto-fill,300px)] w-full max-w-[1000px] mt-4 justify-center"
            data-intercom-other-schedules-new-grid
        >
            <div className="col-span-full">
                <SearchV2 placeholder="Search for a template..." onChange={setSearch} />
            </div>
            {isLoading || isFetching ? (
                <>
                    {[...Array(10).keys()].map((_, i) => {
                        return <div key={i} className="animate-pulse bg-gray-100 h-[125px] rounded"></div>;
                    })}
                </>
            ) : (
                <>
                    <BlankCard onCreate={(): void => setShowManualForm(true)} disabled={isCreating} />
                    {templates.map((template) => {
                        return (
                            <CalculationTemplateCard
                                key={template.id}
                                template={template}
                                disabled={isCreating}
                                calculation={calculations.find(
                                    (c) => c.templateId === template.id && c.behaviour === CWTBehaviourEnum.SHARE
                                )}
                                onCreating={(): void => setIsCreating(true)}
                                onCreate={(): void => setIsCreating(false)}
                            />
                        );
                    })}
                </>
            )}
        </div>
    );
}

export default NewOtherScheduleForm;
